export default "__VITE_ASSET__YqMW9Ucf__"